"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownOption = exports.DropdownOptionRenderer = exports.DropdownOptionWrapper = exports.DropdownOptionPlaceholder = void 0;
const horizon_util_ts_tokens_1 = require("@daytrip/horizon-util-ts-tokens");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Dimensions_1 = require("../utils/Dimensions");
exports.DropdownOptionPlaceholder = styled_components_1.default.span `
    color: ${horizon_util_ts_tokens_1.Colors.Grey200};
`;
exports.DropdownOptionWrapper = styled_components_1.default.div `
    font-size: ${Dimensions_1.Dimensions.d14};
    line-height: ${Dimensions_1.Dimensions.d20};
    font-weight: 400;
    padding: ${Dimensions_1.Dimensions.d8} ${Dimensions_1.Dimensions.d12};

    &:hover {
        background-color: ${horizon_util_ts_tokens_1.Colors.Blue100};
        color: ${horizon_util_ts_tokens_1.Colors.Blue600};
    }

    ${({ isFocused }) => isFocused &&
    (0, styled_components_1.css) `
            background-color: ${horizon_util_ts_tokens_1.Colors.Blue100};
            color: ${horizon_util_ts_tokens_1.Colors.Blue500};
        `}
`;
const DropdownOptionRenderer = (props) => {
    const { optionRenderer, content, placeholder } = props;
    if (!(content || placeholder)) {
        return null;
    }
    const placeholderID = "__placeholder";
    const defaultOptionRender = (option) => {
        if (option.value === placeholderID) {
            return react_1.default.createElement(exports.DropdownOptionPlaceholder, null, option.label);
        }
        return option.label;
    };
    const definedOptionRender = optionRenderer || defaultOptionRender;
    const displayContent = content || { label: placeholder, value: placeholderID };
    return definedOptionRender(displayContent);
};
exports.DropdownOptionRenderer = DropdownOptionRenderer;
const DropdownOption = (props) => {
    const { isFocused, onSelect, ...contentRenderer } = props;
    return (react_1.default.createElement(exports.DropdownOptionWrapper, { isFocused: isFocused, onClick: onSelect, onMouseDown: (event) => {
            // This is intended, do not remove. Fixes Safari onClick/onBlur dispatch order.
            event.preventDefault();
        } },
        react_1.default.createElement(exports.DropdownOptionRenderer, { content: contentRenderer.content, optionRenderer: contentRenderer.optionRenderer }, contentRenderer.children)));
};
exports.DropdownOption = DropdownOption;
//# sourceMappingURL=DropdownOption.js.map